import React from 'react';
import { Button } from 'UI';

import {
  MainContainer,
} from './style';

interface ExtraProps {
  onSave: () => void
  onSendToProduction?: () => void
  isLoading: boolean
  isDisabled?: boolean
}

const Extra = ({
  onSave,
  onSendToProduction,
  isLoading: externalLoading,
  isDisabled: externalDisabled = false,
}: ExtraProps): JSX.Element => (
  <MainContainer>
    {onSendToProduction && (
      <Button
        onClick={onSendToProduction}
        type="ghost"
        disabled={externalLoading || externalDisabled}
        loading={externalLoading}
      >
        Enviar para semeio
      </Button>
    )}
    <Button
      onClick={onSave}
      disabled={externalLoading || externalDisabled}
      loading={externalLoading}
    >
      Salvar
    </Button>
  </MainContainer>
);

export default Extra;
